import pluralize from 'pluralize';
import React from 'react';
import { BulkActionModal } from '~/components/bulk-action';
import { useApi, useWorkspace } from '~/contexts';
import ExpenseReportDetails from './ExpenseReportDetails';

export default function BulkDelete({ ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  return (
    <BulkActionModal
      title="Bulk Delete"
      variant="delete"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .expenseReports()
          .bulkDelete(ids)
          .then((r) => r.data)
      }
      renderRow={ExpenseReportDetails}>
      {`Are you sure you want to delete ${ids.length} ${pluralize('expense report', ids.length)}? This action cannot be undone.`}
    </BulkActionModal>
  );
}
